module.exports = __webpack_public_path__ + "assets/img/hbjh1.4ca4d2a0.png";